module.exports = __webpack_public_path__ + "static/media/accenture.99690d44.png";